import styled from '@emotion/styled'

const ArcadeDivider = styled.hr`
  border-width: 0;
  border-top: ${({ theme }) => theme.pxToRem(1)} solid ${props => props.theme.arcadeColors.component.uiDividerBorder};
`

export default ArcadeDivider
